// extracted by mini-css-extract-plugin
export default {"table":"Users_table__dGZpg"};